import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ValidateBooking {
	uriParams: Api.Operations['validateBooking']['parameters']['path']
	body: Api.Schemas['BookingValidateRequest']
	response: Api.Schemas['BookingValidateResponse']
}

export const validateBooking = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ValidateBooking>(
		{
			method: 'post',
			url: '/bookings/{bookingId}/validate',
			...overideConfig,
		},
		axiosInstance,
	)
